
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { v4 as uuid } from "uuid";
import storage from "@/services/storage";

import Processing from "@/components/common/Processing.vue";
import ImageCropper from "@/components/common/ImageCropper.vue";

@Component({
  components: {
    ImageCropper,
    Processing,
  },
})
export default class FormPhoto extends Vue {
  @Prop({ type: String, default: undefined }) readonly value?: string;
  @Prop({ type: String, default: "Photo" }) readonly labelText!: string;

  dialog: boolean = false;

  image: any = null;

  filepath: string = "";

  processing: boolean = false;
  
  @Watch("value", { immediate: true })
  async watchValue(): Promise<void> {
    if (this.value) {
      await this.getFile(this.value);
    }
  }

  chooseFiles(): void {
    (this.$refs.fileUpload as HTMLElement).click();
  }


  loadImage(event: any): void {
    const input = event.target;

    if ((input as HTMLInputElement).files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.image = (e.target as FileReader).result;
      };
      reader.readAsDataURL(input.files[0]);
    }
    input.value = "";
  }


  async filesChange(event: any): Promise<void> {
    this.loadImage(event);
    this.dialog = true;
  }

  async handleImageCropped(blob: any): Promise<void> {
    const name = `${uuid()}.jpeg`;
    await this.s3BucketUpload(name, blob);
    this.update(name);
    this.image = null;
  }

  update(key: any): void {
    this.$emit("input", key);
  }

  handleCloseModal(): void {
    this.image = null;
    this.dialog = false;
  }
  
  async s3BucketUpload(name: string, file: any): Promise<void> {
    try {
      this.processing = true;
      if (file) {
        await this.setFile(name, file);
        if (this.value) {
          await this.deleteFile(this.value);
        }
        await this.getFile(name);
      }
    } catch (e) {}
    this.processing = false;
  }

  async setFile(key: string, file: any): Promise<void> {
    await storage.save(key, file)
      .then((result: any) => {
        this.filepath = result.key;
      })
      .catch(() => this.filepath = "");
  }

  async getFile(key: string): Promise<void> {
    await storage.get(key)
      .then((result: any) => {
        return (this.filepath = result);
      })
      .catch(() => this.filepath = "");
  }

  async deleteFile(key: string) {
    await storage.delete(key)
      .catch(() => this.filepath = "");
  }
};
